<template>
    <div style="width: 100%">
        <v-layout row class="ma-0" v-if="isEdit">
                <div style="width: 80px;height: 80px;border-radius: 2px;border: 1px dashed rgba(128, 128, 128, 1);position: relative;cursor: pointer;">
                    <v-layout column class="ma-0" align-center fill-height justify-center>
                        <div style="font-size: 16px;color: rgba(25, 118, 210, 1)" class="iconfontFamily">&#xe655;</div>
                        <div style="font-size: 14px;color: rgba(128, 128, 128, 1)">图片/视频</div>
                    </v-layout>
                    <input ref="uploadPicAndVid" type="file" accept="image/jpg,image/png,image/jpeg,video/mp4, video/wmv, video/avi" style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer;" @change="getFile">
                </div>
            <div v-if="imageList.length>0" style="width: 80px;height: 80px;position: relative;margin-left: 10px;cursor: pointer;border-radius:3px;" @click="goToView(1)">
                <v-img :src="imageList[0].thumb" width="100%" height="100%" style="border-radius:3px;"></v-img>
                <div v-if="imageList[0].type ==='video'" style="position: absolute;top: 0;left: 0;width: 80px;height: 80px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                        <div style="font-size: 16px;color: white" class="iconfontFamily">&#xe65e;</div>
                    </v-layout>
                </div>
            </div>
            <div v-if="imageList.length > 1" style="width: 80px;height: 80px;position: relative;margin-left: 10px;cursor: pointer;border-radius:3px;" @click="goToView(1)">
                <v-img :src="imageList[1].thumb" width="100%" height="100%" style="border-radius:3px;"></v-img>
                <div v-if="imageList[1].type ==='video' && imageList.length === 2" style="position: absolute;top: 0;left: 0;width: 80px;height: 80px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                        <div style="font-size: 16px;color: white" class="iconfontFamily">&#xe65e;</div>
                    </v-layout>
                </div>
                <div v-if="imageList.length > 2" style="position: absolute;top: 0;left: 0;width: 80px;height: 80px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                        <div style="font-size: 20px;color: white;line-height: 30px">+{{imageList.length-2}}</div>
                    </v-layout>
                </div>
            </div>
        </v-layout>
        <v-layout v-else row class="ma-0">
            <div v-if="imageList.length>0" style="width: 80px;height: 80px;position: relative;cursor: pointer;border-radius:3px;" @click="goToView(0)">
                <v-img :src="imageList[0].thumb" width="100%" height="100%" style="border-radius:3px;"></v-img>
                <div v-if="imageList[0].type ==='video'" style="position: absolute;top: 0;left: 0;width: 80px;height: 80px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                        <div style="font-size: 16px;color: white" class="iconfontFamily">&#xe65e;</div>
                    </v-layout>
                </div>
            </div>
            <div v-if="imageList.length>1" style="width: 80px;height: 80px;position: relative;margin-left: 10px;cursor: pointer;border-radius:3px;" @click="goToView(0)">
                <v-img :src="imageList[1].thumb" width="100%" height="100%" style="border-radius:3px;"></v-img>
                <div v-if="imageList[1].type ==='video'" style="position: absolute;top: 0;left: 0;width: 80px;height: 80px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                        <div style="font-size: 16px;color: white" class="iconfontFamily">&#xe65e;</div>
                    </v-layout>
                </div>
            </div>
            <div v-if="imageList.length > 2" style="width: 80px;height: 80px;position: relative;margin-left: 10px;cursor: pointer;border-radius:3px;" @click="goToView(0)">
                <v-img :src="imageList[2].thumb" width="100%" height="100%" style="border-radius:3px;"></v-img>
                <div v-if="imageList[2].type ==='video' && imageList.length === 2" style="position: absolute;top: 0;left: 0;width: 80px;height: 80px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                        <div style="font-size: 16px;color: white" class="iconfontFamily">&#xe65e;</div>
                    </v-layout>
                </div>
                <div v-if="length > 2" style="position: absolute;top: 0;left: 0;width: 80px;height: 80px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                        <div style="font-size: 20px;color: white;line-height: 30px">+{{imageList.length-2}}</div>
                    </v-layout>
                </div>
            </div>
        </v-layout>
        <!--提示Snackbar-->
        <picture-video-previewer ref="previewer" :showDelete="isShowDelete"  :info-list="imageList" @removeMedia="removeMedia"></picture-video-previewer>
    </div>
</template>

<script>
    import PictureVideoPreviewer from '@/components/picture_video_previewer/PictureVideoPreviewer'
    export default {
        name: "UploadPictureAndVideo",
        props:["value","uploadIndex","isEdit"],
        components:{
            PictureVideoPreviewer
        },
        data(){
            return{
                imageList:this.value,
                isShowDelete:false
            }
        },
        methods:{
            getFile(){
                if(this.imageList.length < 15){
                    let file = this.$refs.uploadPicAndVid.files[0];
                    if(file.type === "video/mp4" || file.type === "video/wmv" || file.type === "video/avi"){
                        this.uploadVideo(file)
                    }else if(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/gif'){
                        this.uploadPicture(file)
                    }else{
                        this.$emit("errorUploadValue","文件格式错误");
                    }
                }else{
                    this.$emit("errorUploadValue","最多上传15张");
                }
            },
            uploadPicture(file){
                if(file.size < 1024 * 1024 * 20){
                    this.$emit("setLoading",true)
                    let paramData = new FormData();
                    paramData.append('multipartFile',file);
                    this.$axios.post('/managerApi/upoladFile/uploadPiture',paramData)
                        .then((resultData)=>{
                            resultData = resultData.data;
                            if(resultData.status == 200){
                                let item={
                                    type:'image',
                                    url:resultData.data.picture,
                                    thumb:resultData.data.thumb,
                                }
                                this.imageList.push(item)
                                let temp={
                                    index:this.uploadIndex,
                                    list:this.imageList
                                }
                                //this.$emit("upload-event",this.imageList)
                                //数据处理
                                this.$emit("addItem",temp)
                            }
                            this.$refs.uploadPicAndVid.value =''
                            this.$emit("setLoading",false)
                        })
                }else{
                    this.$emit("errorUploadValue","文件大小不能超过20M");
                }
            },
            uploadVideo(file){
                if(file.size < 1024 * 1024 * 500){
                    this.$emit("setLoading",true)
                    let data = new FormData()
                    data.append('multipartFile',file)
                    this.$axios.post('/managerApi/upoladFile/uploadVideo',data)
                        .then((resultData)=>{
                            resultData = resultData.data;
                            if(resultData.status == 200){
                                let item={
                                    type:'video',
                                    url:resultData.data.picture,
                                    thumb:resultData.data.thumb,
                                }
                                this.imageList.push(item)
                                let temp={
                                    index:this.uploadIndex,
                                    list:this.imageList
                                }
                                //this.$emit("upload-event",this.imageList)
                                //数据处理
                                console.log(resultData.data.picture)
                                this.$emit("addItem",temp)
                            }
                            this.$refs.uploadPicAndVid.value =''
                            this.$emit("setLoading",false)
                        })
                }else{
                    this.$emit("errorUploadValue","文件大小不能超过500M");
                }
            },
            goToView(val){
                if(val === 1){
                    this.isShowDelete = true
                }else
                    this.isShowDelete = false
                this.$refs.previewer.showPreviewDialog = true
            },
            removeMedia(list){
                this.imageList = list
                let temp={
                    index:this.uploadIndex,
                    list:list
                }
                this.$emit("addItem",temp)
                console.log(list)
            }
        }
    }
</script>

<style scoped>

</style>
